import React from 'react';
import { withPrefix } from 'gatsby-link'

import './image-gallery.css'

class Image extends React.Component {

  handleClick() {
    let index = this.props.index;
    this.props.onClick(index);
  }

  render() {

    return (
      <div className="gallery-img-container">
        <img
          className="gallery-img"
          onClick={() => this.handleClick()}
          src={this.props.src}/>
        </div>

    );
  }
}

export default {Image}



// WEBPACK FOOTER //
// ./src/components/ImageGallery/image.js